<template>
    <router-link
        v-if="!anchor"
        :to="`/produktkategorien/${data.slug.name}`"
        class="rounded-md shadow-md hover:shadow-lg p-4 flex flex-row items-center gap-4 cursor-pointer"
        :class="animate ? 'transition-all ease-in-out group' : ''"
    >
        <div class="w-12 h-12 rounded-md text-white flex-shrink-0">
            <img :alt="$translate(data.name)" :src="data.image.replace('.png', '-gradient.png')" class="w-full h-full object-contain" />
        </div>
        <div class="group-hover:ml-2 transition-all ease-in-out">
            <h4 class="base_bold">
                {{ $translate(data.name) }}
            </h4>
            <small>
                {{ $t('plain_learn_more') }}
            </small>
        </div>
    </router-link>
    <div
        v-else
        @click="$emit('jumpToCategory', data)"
        class="rounded-md shadow-md hover:shadow-lg p-4 flex flex-row items-center gap-4 cursor-pointer"
        :class="animate ? 'transition-all ease-in-out group' : ''"
    >
        <div class="w-12 h-12 rounded-md text-white flex-shrink-0">
            <img :alt="$translate(data.name)" :src="data.image.replace('.png', '-gradient.png')" class="w-full h-full object-contain" />
        </div>
        <div class="group-hover:ml-2 transition-all ease-in-out">
            <h4 class="base_bold">
                {{ $translate(data.name) }}
            </h4>
            <small>
                {{ $t('plain_learn_more') }}
            </small>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        data: Object,
        animate: Boolean,
        anchor: Boolean
    },

    computed: {
        text() {
            return this.data.background_color;
        }
    }
};
</script>
